export abstract class Mappable<T> {
    constructor(partial?: Partial<T>) {
        return Object.assign(this, partial);
    }
}
